export default __webpack_public_path__ + "static/new-gdpr-63dc307f2da3bb85fd0b87276315ce44.png";